var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.239,
    height: 70.239,
    viewBox: "0 0 70.239 70.239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1625",
    "data-name": "Rectangle 1625",
    width: 70.239,
    height: 70.239,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "brand-icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3812",
    "data-name": "Group 3812",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60291",
    "data-name": "Path 60291",
    d: "M18.224,19.06a.894.894,0,0,0-1.2-.32.882.882,0,0,0-.323,1.2l1.427,2.466a.93.93,0,0,0,.139.181.879.879,0,0,0,1.381-1.061Z",
    transform: "translate(33.542 37.668)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60292",
    "data-name": "Path 60292",
    d: "M23.523,17.011l-2.466-1.424A.878.878,0,0,0,20,16.969a.929.929,0,0,0,.181.139l2.466,1.424a.878.878,0,1,0,.88-1.52",
    transform: "translate(39.921 31.287)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60293",
    "data-name": "Path 60293",
    d: "M16.235,20.137a.879.879,0,1,0-1.7.453L16.2,26.814a.905.905,0,0,0,.224.393.891.891,0,0,0,.852.23A.878.878,0,0,0,17.9,26.36Z",
    transform: "translate(29.337 39.405)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60294",
    "data-name": "Path 60294",
    d: "M19.868,17.51a.878.878,0,0,0-1.242,1.242l4.555,4.555a.878.878,0,0,0,1.242-1.242Z",
    transform: "translate(37.151 34.895)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60295",
    "data-name": "Path 60295",
    d: "M27.927,15.09,21.7,13.422a.878.878,0,0,0-.846,1.469.854.854,0,0,0,.393.227l6.223,1.668a.878.878,0,1,0,.453-1.7",
    transform: "translate(41.662 27.082)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60296",
    "data-name": "Path 60296",
    d: "M3.656,7.241,6.123,8.665a.879.879,0,0,0,1.2-.32A.892.892,0,0,0,7,7.144L4.536,5.721A.877.877,0,0,0,3.475,7.1a.838.838,0,0,0,.181.142",
    transform: "translate(6.508 11.331)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60297",
    "data-name": "Path 60297",
    d: "M8.258,5.886a.838.838,0,0,0,.142.181A.877.877,0,0,0,9.779,5.006L8.355,2.54a.878.878,0,1,0-1.52.88Z",
    transform: "translate(13.585 4.254)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60298",
    "data-name": "Path 60298",
    d: "M1.766,9.326l6.223,1.668a.878.878,0,1,0,.453-1.7L2.219,7.631A.877.877,0,0,0,1.373,9.1a.854.854,0,0,0,.393.227",
    transform: "translate(2.254 15.37)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60299",
    "data-name": "Path 60299",
    d: "M8.71,8.837A.878.878,0,1,0,9.952,7.595L5.4,3.04A.878.878,0,1,0,4.155,4.282Z",
    transform: "translate(7.881 5.625)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60300",
    "data-name": "Path 60300",
    d: "M10.414,7.327a.854.854,0,0,0,.227.393.877.877,0,0,0,1.469-.846L10.441.65a.878.878,0,0,0-1.7.453Z",
    transform: "translate(17.625 -0.001)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60301",
    "data-name": "Path 60301",
    d: "M66.684,33.279l.042-13.8a.856.856,0,0,0-.257-.623L61.519,13.9c3.693-2.539,7.78-6.365,8.142-9.593a3.638,3.638,0,0,0-1.019-3.035C67.5.18,65.083-1.11,60.67,2.873A32.209,32.209,0,0,0,56,8.383L51.043,3.426a.878.878,0,0,0-.623-.257l-13.8.045a.879.879,0,0,0-.62.257L.257,39.212a.879.879,0,0,0,0,1.242l14.6,14.592,14.592,14.6a.876.876,0,0,0,1.239,0L66.428,33.9a.879.879,0,0,0,.257-.62M63.852,2.659c2.333-1.39,3.24-.462,3.53-.16a1.856,1.856,0,0,1,.535,1.614c-.284,2.539-4.083,6.114-7.662,8.526L57.282,9.668c1.768-2.7,4.177-5.582,6.571-7.009m1.079,30.255L30.064,67.781l-4.63-4.63,5.737-5.737a.878.878,0,0,0-1.242-1.242l-5.734,5.737-1.668-1.665,4.068-4.068a.878.878,0,1,0-1.242-1.242L21.287,59l-1.665-1.665,4.065-4.068a.877.877,0,0,0-1.242-1.239L18.38,56.093l-1.665-1.665,5.734-5.737a.877.877,0,1,0-1.242-1.239l-5.734,5.734L13.807,51.52l4.065-4.068a.878.878,0,1,0-1.242-1.242l-4.065,4.068L10.9,48.612l4.065-4.068A.877.877,0,0,0,13.722,43.3L9.657,47.37,7.991,45.7l5.734-5.737a.877.877,0,1,0-1.242-1.239L6.749,44.462l-4.63-4.63L36.983,4.968l13.078-.039L55.03,9.9a22.812,22.812,0,0,0-1.535,2.974,4.149,4.149,0,1,0,1.653.6A24.417,24.417,0,0,1,56.333,11.2l8.638,8.638ZM53.174,16.6c.03.036.063.073.1.109a2.189,2.189,0,0,0,2.049.342,2.42,2.42,0,0,1-4.135,1.662,2.42,2.42,0,0,1,1.765-4.135,2.423,2.423,0,0,0,.224,2.022m1.375-1.206a1.461,1.461,0,0,1,.018-.151l.048.039c.03.03.051.066.082.1-.054.006-.112.015-.148.015",
    transform: "translate(0 0.339)",
    fill: "#051631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60302",
    "data-name": "Path 60302",
    d: "M27.362,17.469l2.351-6.93A.914.914,0,0,0,28.6,9.426l-6.93,2.348L15.807,7.4a.879.879,0,0,0-1.4.716l.094,7.317L8.523,19.654a.878.878,0,0,0-.36.855.865.865,0,0,0,.608.7l6.985,2.17,2.173,6.988a.842.842,0,0,0,.218.36.873.873,0,0,0,1.336-.115l4.225-5.972,7.317.094a.877.877,0,0,0,.713-1.4Zm-4.092,5.41a.879.879,0,0,0-.728.372l-3.464,4.9L17.3,22.42a.886.886,0,0,0-.58-.577l-5.728-1.78,4.9-3.464a.887.887,0,0,0,.372-.728l-.079-6,4.809,3.588a.886.886,0,0,0,.807.13L27.48,11.66l-1.928,5.682a.876.876,0,0,0,.127.807l3.588,4.809Z",
    transform: "translate(16.487 14.611)",
    fill: "#ec431f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandIcon);
export default __webpack_public_path__ + "static/media/brand-icon.957dd120bf41bb68e093a20220441690.svg";
export { ForwardRef as ReactComponent };